import * as React from 'react';

import * as style from './TableBody.css';

export const TableBody: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return <tbody className={style['body']}>{children}</tbody>;
};
